'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = shallowEqual;

var _objectIs = require('./objectIs');

var _objectIs2 = _interopRequireDefault(_objectIs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {Object} objA
 * @param {Object} objB
 * @returns {boolean} true if `objA[x] === objB[x]` for all `x`, and vice versa
 */
function shallowEqual(objA, objB) {
  if ((0, _objectIs2.default)(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !(0, _objectIs2.default)(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.100/js/shallowEqual.js
// module id = 605
// module chunks = 177